// 全球	https://uwant.global/
// 美国	uwanthome.com
// 香港	uwant.com.hk
// 以色列	https://uwant.co.il/
// 日本	https://uwanthome.jp/
// 北欧	https://uwant.dk/
// 俄国	http://uwant.ru
// 欧洲	https://uwant.eu/

(function () {
  const countryRedirectMap = {
    // US: 'https://uwanthome.com',
    HK: 'https://uwant.com.hk',
    IL: 'https://uwant.co.il',
    JP: 'https://uwanthome.jp',
    RU: 'http://uwant.ru',
  };

  //欧洲
  const EUList = ['DE', 'FR', 'IT', 'ES'];
  const EULink = 'https://uwant.eu';

  //北欧
  const DKList = ['DK', 'FI', 'NO', 'SE', 'IS'];
  const DKLink = 'https://uwant.dk';

  const removeVOpacity = () => {
    const el = document.getElementById('page-index');

    if (el) {
      setTimeout(() => {
        el.classList.remove('v-geo-redirect-hidden');
        console.log('v-geo-redirect-hidden removed');
      }, 100);
    } else {
      setTimeout(() => {
        document
          .getElementById('page-index')
          .classList.remove('v-geo-redirect-hidden');
      }, 200);
    }
  };

  let isGeoRedirectChecked = false;

  if (isGeoRedirectChecked) {
    console.log('isGeoRedirectChecked', isGeoRedirectChecked);
    removeVOpacity();
    return;
  }

  const hostname = location.hostname;

  if (
    !(
      hostname == 'localhost' ||
      hostname == '127.0.0.1' ||
      hostname == 'uwant.global' ||
      hostname == 'www.uwant.global'
    )
  ) {
    removeVOpacity();
    return;
  }

  fetch('/browsing_context_suggestions.json')
    .then((response) => response.json())
    .then((data) => {
      isGeoRedirectChecked = true;

      if (data.detected_values && data.detected_values.country) {
        const country = data.detected_values.country.handle;

        if (countryRedirectMap.hasOwnProperty(country)) {
          const targetDomain = countryRedirectMap[country];
          console.log('country, targetDomain', country, targetDomain);
          document.body.innerHTML = '';
          window.location.href = targetDomain;
        } else if (DKList.includes(country)) {
          document.body.innerHTML = '';
          window.location.href = DKLink;
        } else {
          removeVOpacity();
        }
      } else {
        removeVOpacity();
      }
    })
    .catch((error) => {
      console.log('Geolocation detection failed:', error);
      isGeoRedirectChecked = true;
      removeVOpacity();
    })
    .finally(() => {
      console.log('finally');

      setTimeout(() => {
        removeVOpacity();
      }, 5000);
    });
})();
